var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.$emit('click')},"keyup":_vm.keyup}},[_c('lottie-animation',{attrs:{"path":_vm.src,"loop":_vm.loop,"width":_vm.width*1,"height":_vm.height*1},on:{"AnimControl":_vm.setAnimController}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }